




























import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class ContactUs extends Vue {
  @Prop() public data!: object;
  @Prop() public isMobile!: boolean;
  @Prop({
    type: Boolean,
    required: false,
    default: false
  })
  private isBg!: boolean;

  public logoUrl = require('@/assets/image/logo_transparent.png'); //logo
  public footerImg = require('@/assets/image/footer_bg.png'); //footer 默认背景图
  public footerImg1 = require('@/assets/image/footer_bg1.png'); //footer 背景图

  get companyInfo() {
    // 转换公司信息为对象
    if (this.data && (this.data as any).customField) {
      return JSON.parse((this.data as any).customField);
    }
    return {};
  }
}
